import React from "react";
import {useNavigate} from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import { NavigationItem, StackLayout } from "@salt-ds/core";
import {pagePath} from "src/app/Routers";
import store from "src/store/store";
import {setActiveTab} from "src/reducers/slices/SetActiveTabSlice";
import {PAYMENTTERM, FAQS} from "src/utils/Constants";
import {setAccordionStateDetails} from "src/reducers/slices/FaqAccordionSlice.ts";

const DefaultTabs = () => {
  const selectedTab = useSelector(
      (state: ReturnType<typeof store.getState>) => state.setActiveTab.value
  );


  const navItems = ["Product Overview", FAQS];
  const [active, setActive] = React.useState(navItems[0]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    switch (selectedTab.activeTab) {
      case "Product Overview":
        setActive("Product Overview");
        return navigate(pagePath.defaultOverview);

      case FAQS:
        setActive(FAQS);
        return navigate(pagePath.defaultFAQ);

      default:
        break;
    }
  }, [selectedTab.activeTab]);



  return (
      <>
        <div>
          <nav>
            <StackLayout
                as="ul"
                direction="row"
                gap={1}
                className=" mt-5 font-semibold text-sm/18 text-[#61656E] "

            >
              {navItems.map((item) => {
                return (
                    <li key={item}>
                      <NavigationItem
                          active={active === item}
                          href="javascript:void(0)"
                          //href= {navPath}
                          onClick={() => {
                            window.scroll(0, 0)
                            setActive(item);
                            dispatch(setActiveTab(item));
                            dispatch(setAccordionStateDetails(""));
                          }}
                      >
                        {item}
                      </NavigationItem>
                    </li>
                );
              })}
            </StackLayout>
          </nav>
        </div>
      </>
  );
};

export default DefaultTabs;
